/* eslint-disable curly */
/* eslint-disable no-empty-function */
import { signal, WritableSignal } from "@angular/core";

type TimeRecord<T> = {
  data: WritableSignal<T|null>;
  created: Date;
}

export class KeyValueTimeCache<K extends string|number|symbol, V> {
  private map = <Record<K, TimeRecord<V>>>{};

  constructor(private validity: number, public identifierGetter: (v: V) => K) {}

  public get(key: K) {
    let record = this.map[key];
    if (!record) {
      record = {
        created: new Date(),
        data: signal(null),
      };
      this.map[key] = record;
      return record.data.asReadonly();
    }
    if (this.valid(record)) return record.data.asReadonly();
    record.data.set(null);
    return record.data.asReadonly();
  }

  public getAnyways(key: K) {
    let record = this.map[key];
    if (!record) {
      record = {
        created: new Date(),
        data: signal(null),
      };
      this.map[key] = record;
    }
    return record.data.asReadonly();
  }

  public has(key: K) {
    const record = this.map[key];
    if (!record) return false;
    if (!this.valid(record)) return false;
    return true;
  }

  public set(value: V) {
    const key = this.identifierGetter(value);
    let record = this.map[key];
    if (!record) {
      record = {
        created: new Date(),
        data: signal(value),
      };
      this.map[key] = record;
    } else {
      record.created = new Date();
      record.data.set(value);
    }
  }

  private valid(record: TimeRecord<V>) {
    return new Date().getTime() - record.created.getTime() <= this.validity;
  }
}
